import { cn } from '@/lib/utils/cn';
import { initialsFrom } from '@/lib/utils/initials';

interface UserAvatarProps {
  name: string;
  email?: string;
  avatarUrl?: string | null;
  size?: 'xs' | 'sm' | 'md';
  className?: string;
}

const sizeClass = { xs: 'size-6 text-[0.625rem]', sm: 'size-7 text-xs', md: 'size-8 text-xs' };

/** Initials avatar; the accessible name comes from the surrounding context/title. */
export function UserAvatar({ name, email, avatarUrl, size = 'md', className }: UserAvatarProps) {
  const label = name.trim() || (email ?? 'Usuario');
  return (
    <span
      title={label}
      className={cn(
        'relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary-soft font-semibold text-primary-soft-foreground ring-2 ring-surface',
        sizeClass[size],
        className,
      )}
    >
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt=""
          className="absolute inset-0 size-full rounded-full object-cover"
          onError={(event) => {
            event.currentTarget.style.display = 'none';
          }}
        />
      ) : null}
      <span aria-hidden="true">{initialsFrom(name, email?.[0]?.toUpperCase() ?? '?')}</span>
      <span className="sr-only">{label}</span>
    </span>
  );
}
